module.exports = __webpack_public_path__ + "img/Visual_Studio_2017_logo_and_wordmark.cf62b6e6.svg";